export default "__VITE_ASSET__BdyQIwk9__"